import api from './axios';

export const cipApi = {
    // Analytics (Aggregated on frontend for now)
    getDashboardMetrics: async () => {
        // Fallback for dashboard if not in backend
        return { message: "Frontend aggregation needed" };
    },
    getTrends: async (params) => {
        return { message: "Frontend aggregation needed" };
    },

    // CIP Preparations (Pending/Approved)
    getPreparations: async (status) => {
        const response = await api.get(`/cip/preparations/`, { params: { status } });
        return response.data;
    },
    startPreparation: async (data) => {
        const response = await api.post('/cip/preparations/', data);
        return response.data;
    },
    updatePreparationStatus: async (id, statusData) => {
        const response = await api.patch(`/cip/preparations/${id}/`, statusData);
        return response.data;
    },

    // CIP Events (Ongoing/Unsuccessful)
    getEvents: async (status) => {
        const response = await api.get(`/cip/events/`, { params: { status } });
        return response.data;
    },

    // Expired CIPs
    getExpiredLoops: async () => {
        const response = await api.get('/cip/expired-loops/');
        return response.data;
    },

    // CIP Loops Configuration
    getLoops: async () => {
        const response = await api.get('/cip/loops/');
        return response.data;
    },
    getLoop: async (id) => {
        const response = await api.get(`/cip/loops/${id}/`);
        return response.data;
    },
    createLoop: async (data) => {
        const response = await api.post('/cip/loops/', data);
        return response.data;
    },
    updateLoop: async (id, data) => {
        const response = await api.put(`/cip/loops/${id}/`, data);
        return response.data;
    },
    deleteLoop: async (id) => {
        const response = await api.delete(`/cip/loops/${id}/`);
        return response.data;
    },

    // CIP Loop Regimes Configuration
    getRegimes: async (params) => {
        const response = await api.get('/cip/loop-regimes/', { params });
        return response.data;
    },
    getRegime: async (id) => {
        const response = await api.get(`/cip/loop-regimes/${id}/`);
        return response.data;
    },
    createRegime: async (data) => {
        const response = await api.post('/cip/loop-regimes/', data);
        return response.data;
    },
    updateRegime: async (id, data) => {
        const response = await api.put(`/cip/loop-regimes/${id}/`, data);
        return response.data;
    },
    deleteRegime: async (id) => {
        const response = await api.delete(`/cip/loop-regimes/${id}/`);
        return response.data;
    },

    // Lookups
    getElements: async (params) => {
        const response = await api.get('/cip/elements/', { params });
        return response.data;
    },
    createElement: async (data) => {
        const response = await api.post('/cip/elements/', data);
        return response.data;
    },
    updateElement: async (id, data) => {
        const response = await api.put(`/cip/elements/${id}/`, data);
        return response.data;
    },
    deleteElement: async (id) => {
        const response = await api.delete(`/cip/elements/${id}/`);
        return response.data;
    },

    getUnits: async (params) => {
        const response = await api.get('/cip/units/', { params });
        return response.data;
    },
    createUnit: async (data) => {
        const response = await api.post('/cip/units/', data);
        return response.data;
    },
    updateUnit: async (id, data) => {
        const response = await api.put(`/cip/units/${id}/`, data);
        return response.data;
    },
    deleteUnit: async (id) => {
        const response = await api.delete(`/cip/units/${id}/`);
        return response.data;
    },

    // Users and Roles
    getUsers: async () => {
        try {
            const response = await api.get('/core/users/');
            return response.data;
        } catch {
            return [];
        }
    },
    getRoles: async () => {
        return [];
    },

    // Activity Log
    getActivityLog: async (params) => {
        return [];
    }
};

export default cipApi;
